import { render, staticRenderFns } from "./GrowthVitaminDialog.vue?vue&type=template&id=e512b2ae&scoped=true&"
import script from "./GrowthVitaminDialog.vue?vue&type=script&lang=js&"
export * from "./GrowthVitaminDialog.vue?vue&type=script&lang=js&"
import style0 from "./GrowthVitaminDialog.vue?vue&type=style&index=0&id=e512b2ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e512b2ae",
  null
  
)

export default component.exports